<template>
  <div class="operators">
    <div class="container">
      <div class="popular">
        <div class="popular-title">
          <h6>Most Popular Packages</h6>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-3 package" v-for="(pk,index) in getPopularPackages" :key="index" @click="setPackage(pk.operator,pk.connection,pk.amount)">
            <div class="package-item" v-scroll-to="'#topup'">
              <div class="d-flex">
                <img :src="pk.image" class="img-fluid" :alt="pk.name" />
                <p class="package_name">{{pk.name}}</p>
                <p class="duration">{{pk.duration}}</p>
              </div>
              <div class="d-flex">
                <p class="connection">{{pk.connection}}</p>
                <p class="price">{{pk.amount}} Tk.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopularPackages",
  data() {
    return {
      bundles: [],
    }
  },
  computed: {
    getPopularPackages() {
      return this.$store.state.popularPackages;
    }
  },
  methods: {
    setPackage(operator,connection,amount) {
      this.$store.commit('setOperator',operator);
      this.$store.commit('setConnectionType',connection);
      this.$store.commit('setAmount',amount);
    }
  }
}
</script>

<style scoped>
.operators img{
  width: 15px;
  height: 15px;
  margin: 1px 10px 0 0;
}
.package {
  cursor: pointer;
  width: 50%;
  margin-bottom: 10px;
}

.package .package-item {
  border: 1px solid #8f2d5630;
  border-radius: 5px;
  padding: 4px;
  background: #FFFFFF;
}

.package-item:hover {
  border: 1px solid #8f2d5661;
}

.package-item:focus {
  border: 1px solid #004a59;
}

.package-item p {
  word-break: break-word;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0.05em;
  text-transform: capitalize;
  margin-bottom: 5px;
}

.package-item .price {
  margin-left: auto;
  background: #8f2d56;
  border-radius: 3px;
  padding: 1px 5px;
  color: #ffffff;
}
.nav-pills .nav-link.active, .nav-pills .show>.nav-link {
  background: #004a59;
  color: #FFFFFF;
  font-weight: bold;
}
.nav-pills .nav-link {
  color: #004a59;
  font-weight: bold;
}
.packages ul>li {
  margin-left: auto;
}
.package_name {
  width: 75%;
  min-height: 36px;
  margin: 0;
}
.duration {
  color: #838587;
  padding: 2px;
  font-size: 10px !important;
  border: 1px solid #8385874a;
  border-radius: 5px;
}
.popular {
  padding: 0 9px;
  margin-top: 25px;
}
.popular-title {
  margin-top: 10px;
}
.popular-title h6 {
  color: #3d4144;
}
</style>